var starken = {
	data () {
		return {
            listOfStarken: [],
			itemSelectedStarken: {},
            url: 'https://gateway.starken.cl/tracking/orden-flete/of/'
		}
	},
	computed: {
	},
	filters: {
	},
	methods:{
		searchOFStarken(of, action = 1) {
			let config = {
				method: 'get',
				url: this.url + of,
				headers: { }
			};

			this.axios(config)
				.then(response => {
                    this.searchOFStarkenResult(response, action)
                })
				.catch(error => {
                    this.searchOFStarkenError(error)
				});
		},
        searchOFStarkenError(error) {
            console.log(error)
            this.searchOFStarkenErrorLocal(error)
        },
        searchOFStarkenErrorLocal(error) {
            console.log('searchOFStarkenErrorLocal no desarrollado', error)
        },
        searchOFStarkenResult(response, action) {
            this.listOfStarken.push(response.data)
            this.searchOFStarkenResultLocal(response, action)
        },
        searchOFStarkenResultLocal(response, action) {
            console.log('searchOFStarkenResultLocal no desarrollado', response, action)
        }
	},
};

export default starken;